// Copyright (c) 2016 Deere & Company

export const getCombinedClaimTypes = (claimTypes, subClaimTypes) => {

    const modifiedClaimTypes = claimTypes.filter(claimType => claimType.key !== 'ZZMK');

    return modifiedClaimTypes.concat(subClaimTypes);

};



// WEBPACK FOOTER //
// ./src/shared/services/build-claim-types.js